import _createClass from "/Users/alisher.aituarov/job/bermond.management/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/alisher.aituarov/job/bermond.management/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var EmailJSResponseStatus = /*#__PURE__*/_createClass(function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);
  this.status = httpResponse ? httpResponse.status : 0;
  this.text = httpResponse ? httpResponse.responseText : 'Network Error';
});